import {createSlice} from '@reduxjs/toolkit'


const initialState = {
    stats: [],
    ready: false,
}


export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        updateStats: (state, action) => {
            state.stats = action.payload
        },
        setLoading: (state, action) =>
        {
            state.ready = action.payload
        },
        setIsLoading: (state, action) =>
        {
            state.isLoading = action.payload
        },
        reset: () => initialState

    }
})

// Action creators are generated for each case reducer function
export const {updateStats, setLoading, setIsLoading} = appSlice.actions

export default appSlice.reducer